import AppCollapse, { FilterBarOptionsActive } from 'views/components/Collapse';
import { Filter } from 'react-feather';
import { useSelector } from 'react-redux';
import * as authSelectors from '@redux/reducers/auth';
import { Media } from 'reactstrap';

interface Props {
  children: any;
  title?: any;
  className?: string;
  active?: boolean;
  onlyHasMembership?: boolean;
  minMembershipLevel?:
    | 'subdivision'
    | 'division'
    | 'organization'
    | 'agent'
    | 'operator'
    | 'system';
  formValues?: any;
  // Props para pasar directamente a AppCollapse (opcionales)
  openCollapse?: number | number[]; // Estado del collapse (qué elementos están abiertos)
  onToggle?: (id: number) => void; // Handler para cuando se hace toggle
  filtersBarOptionsActive?: FilterBarOptionsActive[]; // Nueva prop opcional
}

const accessLevels = {
  subdivision: {
    accessLevelId: [2, 20],
    priorityOrder: 20
  },
  division: {
    accessLevelId: [4],
    priorityOrder: 30
  },
  organization: {
    accessLevelId: [7],
    priorityOrder: 50
  },
  agent: {
    accessLevelId: [11],
    priorityOrder: 60
  },
  operator: {
    accessLevelId: [13],
    priorityOrder: 80
  },
  system: {
    accessLevelId: [9, 15],
    priorityOrder: 100
  }
};

const CollapseFilters = (props: Props) => {
  const {
    children,
    title,
    className = '',
    active = false,
    onlyHasMembership = false,
    minMembershipLevel = 'division',
    formValues,
    openCollapse,
    onToggle,
    filtersBarOptionsActive
  } = props;

  const user = useSelector(authSelectors.getAuthUserForMembership);

  return !onlyHasMembership ||
    !Object.values(accessLevels)
      .reduce(
        (array: number[], value) =>
          value.priorityOrder < accessLevels[minMembershipLevel].priorityOrder
            ? [...array, ...value.accessLevelId]
            : array,
        []
      )
      .includes(parseInt(user?.accessLevelId)) ? (
    <AppCollapse
      type="border"
      accordion
      className={className}
      active={active ? 0 : undefined}
      formValues={formValues}
      openCollapse={openCollapse}
      onToggle={onToggle}
      filtersBarOptionsActive={filtersBarOptionsActive}
      data={[
        {
          title: (
            <Media>
              <Filter size={18} />
              {title ? <div className={'ml-1'}>{title}</div> : ''}
            </Media>
          ),
          content: children
        }
      ]}
    />
  ) : (
    children
  );
};

export default CollapseFilters;
